import {useMemo} from 'react'
import {useController} from 'react-hook-form'

import type {AddressPin} from '../../../../../api/address'
import {FieldName} from '../../../lib/fieldNames'

/**
 * Возвращает отсортированный (от точки отправления до точки прибытия) массив с адресами маршрута
 */
export const useAddresses = () => {
  const {field} = useController({name: FieldName.Route})

  return useMemo<AddressPin[]>(
    () =>
      Object.keys(field.value ?? {})
        .sort((a, b) => {
          // 'source' всегда должен быть первым
          if (a === 'source') {
            return -1
          }

          // 'source' всегда должен быть первым
          if (b === 'source') {
            return 1
          }

          // Извлечение числовой части из строки вида 'destination_*'
          const numA = parseInt(a.split('_')[1], 10)
          const numB = parseInt(b.split('_')[1], 10)

          // Сравнение числовых частей
          return numA - numB
        })
        .map(key => field.value[key].address),
    [field.value],
  )
}
